import React, { useState } from "react";
import classes from "src/components/Welcome/Welcome.module.scss";
 import { useTranslation } from "react-i18next";
 import { resetPassword } from "src/api/user-api";
   import type { AxiosError, AxiosResponse } from "axios";
    import type { ResetUserModel} from "src/interfaces/ResetUser";
import { useParams ,useNavigate} from "react-router-dom";
  import { CustomLoader } from "src/components";
export default function ResetUserPassword() {
      
       const [password, setPassword] = useState("");
       const [confirmPassword, setConfirmPassword] = useState("");
       const { t } = useTranslation();
       const [success, setSuccess] = useState(false);
        const [apiError, setApiError] = useState<string | null>(null);
        
        const [isLoading, setIsLoading] = useState(false);
     
  const { token} = useParams();
    const navigate = useNavigate();
    console.log (token);
const params = useParams<{ userId: string }>();
const userId: number | undefined = params.userId ? Number(params.userId) : undefined;
  const [errors, setErrors] = useState<Record<string, string>>({});
       const validateRegister = () => {
  const newErrors: Record<string, string> = {};

  
  if (!password) newErrors.password = "Password is required";
  if (!confirmPassword) newErrors.confirmPassword = "Confirm password is required";
  if (password && confirmPassword && password !== confirmPassword) {
    newErrors.confirmPassword = "Passwords do not match";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
function resetUserPassoword(){
    const isValid = validateRegister();
    if(!isValid){return;}
    setIsLoading(true)
             if ( password !== confirmPassword) {
    return;
            } 
             const data: ResetUserModel = {
                emailAddress: "",
                 id:userId,
                 password:password,
                 token:token
                // add other IUser fields if required
              };
resetPassword(data)
   .then((res: AxiosResponse) => {
      setIsLoading(false)
    setApiError(res.data)
  if(res.data =="Success"){
     setSuccess(true);
     
}
   })  .catch((err: AxiosError) => {
    setSuccess(false);
    setIsLoading(false)
    if(err.response){
     setApiError(err.response.data as string);
    }

  });
        }
        if (apiError !=null) {
  return (
    <div className={classes.PasswordWrapper}>
    <div className={classes.Header}>
      <div className={classes.LoginTitle}>
        {apiError}
      </div>

      <button
        className={classes.SignInBtn}
        onClick={() => navigate("/login")}
      >
        Go to Sign In
      </button>
    </div></div>
  );
}
  return (
 <div className={classes.PasswordWrapper}>
      {isLoading &&  <CustomLoader /> }
    <div className={classes.Header}>
          <div className={classes.LoginTitle}>{t("form.createPassword")}</div>
        
        {userId && <div className={classes.LoginBox}>
              <span>
       <i className="fa fa-lock"></i>
       </span>
      <input
               type="password"
               placeholder="Password"
               value={password}
               onChange={(e) => {
         setPassword(e.target.value);
         setErrors((prev) => ({ ...prev, password: "" }));
       }}
             />
      {errors.password && (
       <span className={classes.ErrorText}>{errors.password}</span>
     )}
     </div>}
       {userId && <div className={classes.LoginBox}>
              <span>
       <i className="fa fa-lock"></i>
       </span>
      <input
               type="password"
               placeholder="ConfirmPassword"
               value={confirmPassword}
               onChange={(e) => {
         setConfirmPassword(e.target.value);
         setErrors((prev) => ({ ...prev, confirmPassword: "" }));
       }}
             />
      {errors.confirmPassword && (
       <span className={classes.ErrorText}>{errors.confirmPassword}</span>
     )}
     </div>}
      <button
      type="button" 
      className={classes.SignInBtn}
      onClick={resetUserPassoword}
    >
   Submit
    </button>
    
    </div></div>
  );
}
